// English web texts of 'Learning surahs' (golf 7). Same shape as memorizeApp.nl.ts.
export const appMemorizeEn = {
    title: 'Learning surahs',
    nav: 'Learning',
    card: {
        body: "Keep track of which surahs your children learn by heart. A child recites, you listen for real and say 'Well heard'. Only then are points added.",
        question: 'Keep track?',
        yes: 'Yes',
        notNow: 'No, not now',
        notNowDone: 'Fine. You can always turn it on here later.',
        on: 'On for {names}.',
        open: 'Go to Learning',
        settings: 'Settings',
        renewal: 'First give consent again in What suits our family.',
    },
    wizard: {
        title: 'Turn on Learning surahs',
        step: 'Step {n} of 4',
        back: 'Back',
        next: 'Next',
        done: 'Turn on',
        who: {
            title: 'Who takes part?',
            body: 'Switch on who takes part. Children under 16, for whom you decide.',
            teen: '{name} decides for themselves. That comes later.',
            otherFaith: '{name} has their own choice of faith and does not take part.',
            none: 'There are no children under 16 in the family.',
            pick: 'Switch on at least one child.',
            and: 'and',
            joins: 'Takes part',
            paused: 'Not taking part now. Progress is kept.',
            notYet: 'Not taking part',
            toggle: '{name} takes part',
            later: 'Switching on first asks for your consent for that child. Switching off keeps the progress.',
            more: 'Let someone else take part too?',
            choose: 'Choose children',
            turnedOn: '{name} takes part.',
            turnedOff: '{name} is not taking part now. Progress is kept.',
        },
        naming: {
            title: 'What do you call the surahs?',
            turkish: 'Fâtiha, İhlâs, Kevser',
            arabic: 'Al-Fatiha, Al-Ikhlas, Al-Kawthar',
            order: 'Order',
            recommended: 'Recommended: {fatiha}, then the shortest',
            prayer: 'Order of the prayer: {fatiha}, {fil} to {nas}',
        },
        board: {
            title: 'Show on the board?',
            body: 'Everyone standing in front of the board sees this for the selected child.',
            yes: 'Yes, on the board',
            no: 'No, only in the app',
        },
        known: {
            title: 'What does each child already know?',
            body: 'Tick what a child already knows by heart. That gives no points and no celebration.',
        },
    },
    consent: {
        title: 'Consent for {name}',
        text: 'We keep track for {name} of which surahs {name} learns and knows, only for your family. You can always withdraw this; then we delete the progress.',
        check: 'I am a parent or guardian of {name} and give consent for this.',
        textMany: 'We keep track for {name} of which surahs they learn and know, only for your family. You can always withdraw this; then we delete the progress.',
        checkMany: 'I am a parent or guardian of {name} and give consent for this.',
        give: 'Give consent',
        withdraw: 'Withdraw consent',
        withdrawConfirm: 'Withdraw consent for {name}? This deletes the progress of {name} straight away. Points already earned stay.',
        withdrawn: 'Consent withdrawn. The progress of {name} has been deleted.',
        given: 'Consent given on {date}.',
        none: 'No consent yet',
    },
    stage: {
        none: 'Not started yet',
        learning: 'Learning',
        ready: 'Wants to recite',
        known: 'By heart',
        review: 'Quick refresh',
    },
    overview: {
        subtitle: 'Which surahs the children learn by heart. Each child at their own pace.',
        now: 'Now working on {item}',
        nothing: 'Nothing started yet',
        next: 'Next: {item}',
        allKnown: '{name} knows the whole list by heart',
        waiting: 'Waiting to be heard ({count})',
        refresh: 'Refresh: {items}',
        list: 'The list',
        settings: 'Settings',
        open: 'View',
        paused: 'Learning surahs is off. Turning it off deletes nothing now. After 12 months off, the progress is deleted.',
        notSet: 'Learning surahs is not on yet.',
        setUp: 'Turn on',
        noConsent: 'No consent yet',
        disabled: 'Not taking part now',
        selfDecides: 'Decides for themselves; comes later',
    },
    member: {
        progress: '{x} of {y} by heart',
        orderLearn: 'Learning order',
        orderMushaf: 'Mushaf order',
        menu: 'What do you want to do with {item}?',
        start: 'Start',
        ready: 'Wants to recite',
        approve: 'Well heard',
        practice: 'Practise a bit more',
        markKnown: 'Has recited this one',
        baseline: 'Already knew this one',
        refresh: 'Quick refresh',
        heard: 'Well heard',
        revert: 'Approved by mistake',
        revertConfirm: 'Undo? {item} will then be back on Learning.',
        revertPoints: 'The {count} points for {item} will be taken off again.',
        negative: 'The balance of {name} will then be negative. Undo anyway?',
        reset: 'Clear',
        resetConfirm: 'Clear {item} for {name}? It will then be back on Not started yet.',
        confirm: 'Yes',
        cancel: 'No',
        upto: 'Up to verse',
        uptoHint: 'For a longer surah: up to where does {name} know it?',
        uptoSave: 'Save',
        uptoClear: 'Clear',
        uptoShort: 'up to verse {n}',
        listen: 'Listen on Quran.com',
        verses: { one: '{count} verse', other: '{count} verses' },
        points: { one: '{count} point', other: '{count} points' },
        reviewRound: 'Review round',
        reviewRoundBody: 'Listen again to a few known surahs. No points, just a quick refresh.',
        reviewRoundEmpty: 'Nothing to refresh right now.',
        reviewRoundDone: 'Review round done.',
        inactive: 'No longer in the list',
        extra: 'Extra',
        heardBy: 'Heard by',
        heardParent: 'me',
        heardTeacher: 'the teacher (hoca)',
        milestones: 'Milestones',
        divider: '{fatiha} and the ten short surahs',
        milestone: {
            fatiha: '{fatiha} by heart',
            prayer_set: '{fatiha} and the ten short surahs',
            starter_set: 'The first twenty surahs',
        },
        done: 'Saved.',
        childBody: 'Tap the button to start or to recite.',
        childStart: 'I am going to start this one',
        childReady: 'I know this one by heart',
        childOops: 'Oops',
        childReadyDone: 'Lovely. A parent will listen soon.',
        agedOut: "From 16, {name} decides for themselves. Saving erases {name}'s progress in Learning surahs; points stay.",
        /** Golf 7 live r1: bevestiging vóór een geboortedatum die een meedoend kind 16+ maakt. */
        agedOutBirth: {
            title: 'Save date of birth?',
            body: "With this date of birth, {name} is 16 or older. From 16, {name} decides for themselves: saving erases {name}'s progress in Learning surahs. Points stay.",
            confirm: 'Save and erase',
        },
    },
    list: {
        body: 'Points are the same for all children.',
        rewardsOff: 'Rewards is off: no points are given.',
        up: 'Move {item} up',
        down: 'Move {item} down',
        drag: 'Drag to move',
        active: 'In the list',
        points: 'Points',
        presets: 'Order with one tap',
        recommended: 'Recommended',
        prayer: 'Order of the prayer',
        more: 'Add more',
        moreBody: 'Extra: Ayat al-Kursi (a verse, not a surah). And surahs 95 down to 78.',
        add: 'Add',
        remove: 'Remove from the list',
        save: 'Save list',
        saved: 'List saved.',
        keptNote: 'Kept, because there is progress.',
    },
    settings: {
        naming: 'Names',
        namingTurkish: 'Turkish: Fâtiha, İhlâs, Kevser',
        namingArabic: 'Arabic: Al-Fatiha, Al-Ikhlas, Al-Kawthar',
        riwaya: 'Reading',
        hafs: 'Hafs',
        warsh: 'Warsh',
        warshNote: 'With Warsh we show no verse numbers and no link: that count differs per print.',
        refresh: 'Refresh after',
        days: '{count} days',
        never: 'Never',
        board: 'Show on the board',
        boardNote: 'Everyone standing in front of the board sees this for the selected child.',
        consent: 'Consent per child',
        wipe: 'Delete everyone’s progress',
        wipeBody: 'Deletes all progress, the list and the settings, and withdraws the consents. Points already earned stay.',
        wipeConfirm: 'Delete everything? This cannot be undone.',
        wiped: 'Learning surahs has been deleted.',
        off: 'Turn off',
        offNote: 'Turning it off deletes nothing now. After 12 months off, the progress is deleted.',
        on: 'Turn on again',
        pointsNote: 'After deleting, points already earned stay. If you turn it on again later, a surah can give points again.',
        saved: 'Saved.',
    },
    approvals: {
        title: 'Recite',
        wants: '{name} wants to recite {item}',
        wantsAgain: '{name} wants to recite {item} again',
        since: 'Since {time}',
        points: { one: '{count} point with Well heard', other: '{count} points with Well heard' },
        approve: 'Well heard',
        practice: 'Practise a bit more',
        heardBy: 'Heard by',
        me: 'me',
        teacher: 'the teacher (hoca)',
        already: 'Already done.',
        approved: '{item}: well heard.',
        practiced: 'Practise a bit more. {name} can recite it again later.',
        seen: 'Seen',
        milestone: '{name}: {text}',
    },
    errors: {
        stale_stage: 'Already done.',
        revert_first: 'First undo Approved by mistake.',
        not_eligible: 'This child does not take part (yet).',
        consent_renewal_required: 'First give consent again in What suits our family.',
    },
};
//# sourceMappingURL=memorizeApp.en.js.map